import { render, staticRenderFns } from "./no-personnel.vue?vue&type=template&id=0080b7e1&scoped=true&"
import script from "./no-personnel.vue?vue&type=script&lang=js&"
export * from "./no-personnel.vue?vue&type=script&lang=js&"
import style0 from "./no-personnel.vue?vue&type=style&index=0&id=0080b7e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0080b7e1",
  null
  
)

export default component.exports